import { AbstractAppService } from "@shopliftr/common-ng";
import {
    Injectable, inject
} from "@angular/core";
import { AppRouterService } from "./app-router.service";
import { IAppConfig } from "../interfaces/app-config";
import { APP_CONFIG } from "../constants/app-config-token";

/**
 * The Application service manages the global state of the application.
 * For example processing or fullscreen
 *
 * This is provided in the app.options.ts for this application
 *
 * Can be injected directly in the application
 * ```
 * readonly appState = inject(AppService);
 * ```
 * @see AbstractAppService
 * @see IAppService
 */
@Injectable()
export class AppService extends AbstractAppService<IAppConfig, AppRouterService> {
    /**
     * Configuration for the SMART Application
     */
    readonly config = inject(APP_CONFIG);

    /**
     * The app router service for SMART
     */
    readonly appRouter = inject(AppRouterService);

}
